var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarvector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.00 0.00 57.00 57.00",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "butt"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#c9cad5",
    vectorEffect: "non-scaling-stroke",
    d: "   M 35.16 6.62   Q 39.09 11.76 37.73 17.65   Q 37.65 18.00 37.30 18.05   Q 37.16 18.07 36.99 18.06"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7e7d81",
    vectorEffect: "non-scaling-stroke",
    d: "   M 36.99 18.06   Q 36.49 17.44 36.03 17.54"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#98979d",
    vectorEffect: "non-scaling-stroke",
    d: "   M 36.03 17.54   Q 36.04 17.23 35.77 17.15   Q 30.70 15.63 25.46 17.41"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7e7d81",
    vectorEffect: "non-scaling-stroke",
    d: "   M 25.46 17.41   L 22.52 19.18"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c9cad5",
    vectorEffect: "non-scaling-stroke",
    d: "   M 22.52 19.18   Q 20.85 13.83 23.03 8.89   Q 23.11 8.69 23.32 8.64   Q 23.50 8.60 23.69 8.56   Q 23.99 8.49 24.08 8.19   Q 24.18 7.82 24.05 7.14"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#51515a",
    vectorEffect: "non-scaling-stroke",
    d: "   M 22.52 19.18   Q 21.73 24.23 22.60 29.74   Q 22.78 30.87 23.01 35.04   Q 23.21 38.63 25.17 42.08"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c9cad5",
    vectorEffect: "non-scaling-stroke",
    d: "   M 25.17 42.08   Q 24.74 41.53 25.98 42.02"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#51515a",
    vectorEffect: "non-scaling-stroke",
    d: "   M 25.98 42.02   L 25.78 47.28"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c9cad5",
    vectorEffect: "non-scaling-stroke",
    d: "   M 25.78 47.28   Q 23.54 47.15 23.43 48.99"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7e7d81",
    vectorEffect: "non-scaling-stroke",
    d: "   M 37.54 39.40   L 37.34 26.30"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#201e22",
    vectorEffect: "non-scaling-stroke",
    d: "   M 36.03 17.54   Q 35.54 17.45 35.33 17.53   Q 35.02 17.64 35.22 17.92   Q 35.67 18.55 36.14 19.16   A 1.44 1.43 27.0 0 1 36.42 20.01   L 36.40 22.96   Q 36.39 23.44 36.78 23.72   Q 37.99 24.62 37.34 26.30"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#98979d",
    vectorEffect: "non-scaling-stroke",
    d: "   M 37.34 26.30   Q 37.13 25.08 35.56 24.57"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#504f56",
    vectorEffect: "non-scaling-stroke",
    d: "   M 35.56 24.57   Q 35.05 21.53 34.77 20.70   Q 33.44 16.81 29.37 17.65   C 28.18 17.90 28.03 18.49 27.08 18.91   Q 26.55 19.14 26.43 19.70   Q 25.93 21.98 25.11 24.49   Q 25.04 24.71 25.31 25.24"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#98979d",
    vectorEffect: "non-scaling-stroke",
    d: "   M 25.31 25.24   Q 25.06 25.43 24.69 25.55"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#201e22",
    vectorEffect: "non-scaling-stroke",
    d: "   M 24.69 25.55   Q 24.71 23.44 24.31 21.51   Q 23.85 19.33 25.58 18.52   Q 26.06 18.30 25.82 17.82   Q 25.71 17.61 25.46 17.41"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6b6b76",
    vectorEffect: "non-scaling-stroke",
    d: "   M 40.83 39.71   Q 40.27 42.39 40.98 44.68"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c9cad5",
    vectorEffect: "non-scaling-stroke",
    d: "   M 39.89 48.42   Q 39.25 47.05 37.40 47.50"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#51515a",
    vectorEffect: "non-scaling-stroke",
    d: "   M 37.40 47.50   Q 37.69 44.57 36.76 41.53"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c9cad5",
    vectorEffect: "non-scaling-stroke",
    d: "   M 36.76 41.53   L 37.54 39.40"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#51515a",
    vectorEffect: "non-scaling-stroke",
    d: "   M 37.54 39.40   Q 38.68 42.59 38.88 36.99   Q 39.13 29.97 38.79 22.94   Q 38.78 22.73 38.93 22.57   Q 38.97 22.54 39.02 22.52   Q 39.50 22.41 39.20 21.96   Q 38.61 21.08 38.59 19.92   A 1.13 1.13 0.0 0 0 38.20 19.09   L 36.99 18.06"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7e7d81",
    vectorEffect: "non-scaling-stroke",
    d: "   M 24.69 25.55   Q 24.42 25.83 24.24 26.16   Q 24.08 26.46 24.13 26.88   Q 24.96 34.19 25.17 42.08"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7e7d81",
    vectorEffect: "non-scaling-stroke",
    d: "   M 27.45 48.26   Q 26.02 48.41 25.78 47.28"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c9cad5",
    vectorEffect: "non-scaling-stroke",
    d: "   M 28.48 48.53   Q 28.41 49.13 28.75 49.13   Q 30.03 49.10 31.25 48.58"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7e7d81",
    vectorEffect: "non-scaling-stroke",
    d: "   M 36.76 41.53   L 35.73 41.82"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#a2a1a8",
    vectorEffect: "non-scaling-stroke",
    d: "   M 35.73 41.82   L 27.21 42.29"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7e7d81",
    vectorEffect: "non-scaling-stroke",
    d: "   M 27.21 42.29   Q 26.42 41.92 25.98 42.02"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#aeaeb5",
    vectorEffect: "non-scaling-stroke",
    d: "   M 35.56 24.57   Q 30.23 23.40 25.31 25.24"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7e7d81",
    vectorEffect: "non-scaling-stroke",
    d: "   M 37.40 47.50   Q 35.63 48.27 34.05 48.34"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#29282d",
    vectorEffect: "non-scaling-stroke",
    d: "   M 34.05 48.34   L 33.73 48.14   Q 33.30 47.88 33.59 47.47   Q 35.31 45.05 35.73 41.82"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#a2a1a8",
    vectorEffect: "non-scaling-stroke",
    d: "   M 34.05 48.34   L 31.25 48.58"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#757581",
    vectorEffect: "non-scaling-stroke",
    d: "   M 31.25 48.58   L 28.48 48.53"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#a2a1a8",
    vectorEffect: "non-scaling-stroke",
    d: "   M 28.48 48.53   Q 27.59 48.79 27.45 48.26"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#29282d",
    vectorEffect: "non-scaling-stroke",
    d: "   M 27.45 48.26   Q 28.84 48.58 29.32 48.06   Q 29.68 47.67 29.37 47.24   Q 27.76 44.99 27.21 42.29"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#a2a1a8",
    vectorEffect: "non-scaling-stroke",
    d: "   M 33.14 38.78   Q 33.73 39.56 34.74 39.50   A 1.32 1.31 88.4 0 0 35.98 38.18   L 35.96 28.76   A 1.41 1.41 0.0 0 0 34.79 27.38   Q 30.76 26.71 26.70 27.76   A 1.41 1.40 79.9 0 0 25.66 29.26   L 26.55 38.03   Q 26.89 41.43 29.38 39.10   Q 30.46 38.09 32.08 38.20   Q 32.74 38.25 33.14 38.78"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f6f6fc",
    d: "   M 35.16 6.62   Q 39.09 11.76 37.73 17.65   Q 37.65 18.00 37.30 18.05   Q 37.16 18.07 36.99 18.06   Q 36.49 17.44 36.03 17.54   Q 36.04 17.23 35.77 17.15   Q 30.70 15.63 25.46 17.41   L 22.52 19.18   Q 20.85 13.83 23.03 8.89   Q 23.11 8.69 23.32 8.64   Q 23.50 8.60 23.69 8.56   Q 23.99 8.49 24.08 8.19   Q 24.18 7.82 24.05 7.14   Q 30.01 5.20 35.16 6.62   Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9c9eae",
    d: "   M 35.16 6.62   Q 38.78 8.29 39.31 11.50   Q 39.94 15.38 39.29 19.79   C 39.18 20.53 39.51 21.13 40.24 21.35   Q 40.78 21.50 40.91 22.05   Q 40.95 22.24 40.84 22.40   Q 40.65 22.69 40.31 22.74   Q 39.63 22.84 39.70 23.52   Q 40.30 29.26 40.30 34.74   C 40.29 36.41 40.64 38.06 40.83 39.71   Q 40.27 42.39 40.98 44.68   L 39.89 48.42   Q 39.25 47.05 37.40 47.50   Q 37.69 44.57 36.76 41.53   L 37.54 39.40   Q 38.68 42.59 38.88 36.99   Q 39.13 29.97 38.79 22.94   Q 38.78 22.73 38.93 22.57   Q 38.97 22.54 39.02 22.52   Q 39.50 22.41 39.20 21.96   Q 38.61 21.08 38.59 19.92   A 1.13 1.13 0.0 0 0 38.20 19.09   L 36.99 18.06   Q 37.16 18.07 37.30 18.05   Q 37.65 18.00 37.73 17.65   Q 39.09 11.76 35.16 6.62   Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#9c9eae",
    d: "   M 24.05 7.14   Q 24.18 7.82 24.08 8.19   Q 23.99 8.49 23.69 8.56   Q 23.50 8.60 23.32 8.64   Q 23.11 8.69 23.03 8.89   Q 20.85 13.83 22.52 19.18   Q 21.73 24.23 22.60 29.74   Q 22.78 30.87 23.01 35.04   Q 23.21 38.63 25.17 42.08   Q 24.74 41.53 25.98 42.02   L 25.78 47.28   Q 23.54 47.15 23.43 48.99   Q 21.70 44.67 21.65 40.07   Q 21.58 33.39 21.55 32.93   Q 21.24 28.74 21.19 24.61   Q 21.19 23.95 20.53 23.89   Q 20.09 23.85 20.08 23.40   Q 20.06 22.96 20.40 22.69   Q 21.64 21.67 21.21 20.02   Q 20.13 15.93 20.51 12.25   Q 20.82 9.21 24.05 7.14   Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3a383e",
    d: "   M 36.03 17.54   Q 35.54 17.45 35.33 17.53   Q 35.02 17.64 35.22 17.92   Q 35.67 18.55 36.14 19.16   A 1.44 1.43 27.0 0 1 36.42 20.01   L 36.40 22.96   Q 36.39 23.44 36.78 23.72   Q 37.99 24.62 37.34 26.30   Q 37.13 25.08 35.56 24.57   Q 35.05 21.53 34.77 20.70   Q 33.44 16.81 29.37 17.65   C 28.18 17.90 28.03 18.49 27.08 18.91   Q 26.55 19.14 26.43 19.70   Q 25.93 21.98 25.11 24.49   Q 25.04 24.71 25.31 25.24   Q 25.06 25.43 24.69 25.55   Q 24.71 23.44 24.31 21.51   Q 23.85 19.33 25.58 18.52   Q 26.06 18.30 25.82 17.82   Q 25.71 17.61 25.46 17.41   Q 30.70 15.63 35.77 17.15   Q 36.04 17.23 36.03 17.54   Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#050406",
    d: "   M 25.46 17.41   Q 25.71 17.61 25.82 17.82   Q 26.06 18.30 25.58 18.52   Q 23.85 19.33 24.31 21.51   Q 24.71 23.44 24.69 25.55   Q 24.42 25.83 24.24 26.16   Q 24.08 26.46 24.13 26.88   Q 24.96 34.19 25.17 42.08   Q 23.21 38.63 23.01 35.04   Q 22.78 30.87 22.60 29.74   Q 21.73 24.23 22.52 19.18   L 25.46 17.41   Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#66666e",
    d: "   M 35.56 24.57   Q 30.23 23.40 25.31 25.24   Q 25.04 24.71 25.11 24.49   Q 25.93 21.98 26.43 19.70   Q 26.55 19.14 27.08 18.91   C 28.03 18.49 28.18 17.90 29.37 17.65   Q 33.44 16.81 34.77 20.70   Q 35.05 21.53 35.56 24.57   Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#050406",
    d: "   M 36.03 17.54   Q 36.49 17.44 36.99 18.06   L 38.20 19.09   A 1.13 1.13 0.0 0 1 38.59 19.92   Q 38.61 21.08 39.20 21.96   Q 39.50 22.41 39.02 22.52   Q 38.97 22.54 38.93 22.57   Q 38.78 22.73 38.79 22.94   Q 39.13 29.97 38.88 36.99   Q 38.68 42.59 37.54 39.40   L 37.34 26.30   Q 37.99 24.62 36.78 23.72   Q 36.39 23.44 36.40 22.96   L 36.42 20.01   A 1.44 1.43 27.0 0 0 36.14 19.16   Q 35.67 18.55 35.22 17.92   Q 35.02 17.64 35.33 17.53   Q 35.54 17.45 36.03 17.54   Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6f6fc",
    d: "   M 35.56 24.57   Q 37.13 25.08 37.34 26.30   L 37.54 39.40   L 36.76 41.53   L 35.73 41.82   L 27.21 42.29   Q 26.42 41.92 25.98 42.02   Q 24.74 41.53 25.17 42.08   Q 24.96 34.19 24.13 26.88   Q 24.08 26.46 24.24 26.16   Q 24.42 25.83 24.69 25.55   Q 25.06 25.43 25.31 25.24   Q 30.23 23.40 35.56 24.57   Z   M 33.14 38.78   Q 33.73 39.56 34.74 39.50   A 1.32 1.31 88.4 0 0 35.98 38.18   L 35.96 28.76   A 1.41 1.41 0.0 0 0 34.79 27.38   Q 30.76 26.71 26.70 27.76   A 1.41 1.40 79.9 0 0 25.66 29.26   L 26.55 38.03   Q 26.89 41.43 29.38 39.10   Q 30.46 38.09 32.08 38.20   Q 32.74 38.25 33.14 38.78   Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4b53",
    d: "   M 32.08 38.20   Q 30.46 38.09 29.38 39.10   Q 26.89 41.43 26.55 38.03   L 25.66 29.26   A 1.41 1.40 79.9 0 1 26.70 27.76   Q 30.76 26.71 34.79 27.38   A 1.41 1.41 0.0 0 1 35.96 28.76   L 35.98 38.18   A 1.32 1.31 88.4 0 1 34.74 39.50   Q 33.73 39.56 33.14 38.78   Q 32.74 38.25 32.08 38.20   Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#3a383e",
    d: "   M 40.83 39.71   Q 41.38 42.19 40.98 44.68   Q 40.27 42.39 40.83 39.71   Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#050406",
    d: "   M 36.76 41.53   Q 37.69 44.57 37.40 47.50   Q 35.63 48.27 34.05 48.34   L 33.73 48.14   Q 33.30 47.88 33.59 47.47   Q 35.31 45.05 35.73 41.82   L 36.76 41.53   Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4b53",
    d: "   M 35.73 41.82   Q 35.31 45.05 33.59 47.47   Q 33.30 47.88 33.73 48.14   L 34.05 48.34   L 31.25 48.58   L 28.48 48.53   Q 27.59 48.79 27.45 48.26   Q 28.84 48.58 29.32 48.06   Q 29.68 47.67 29.37 47.24   Q 27.76 44.99 27.21 42.29   L 35.73 41.82   Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#050406",
    d: "   M 25.98 42.02   Q 26.42 41.92 27.21 42.29   Q 27.76 44.99 29.37 47.24   Q 29.68 47.67 29.32 48.06   Q 28.84 48.58 27.45 48.26   Q 26.02 48.41 25.78 47.28   L 25.98 42.02   Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6f6fc",
    d: "   M 25.78 47.28   Q 26.02 48.41 27.45 48.26   Q 27.59 48.79 28.48 48.53   Q 28.41 49.13 28.75 49.13   Q 30.03 49.10 31.25 48.58   L 34.05 48.34   Q 35.63 48.27 37.40 47.50   Q 39.25 47.05 39.89 48.42   Q 31.89 54.07 23.43 48.99   Q 23.54 47.15 25.78 47.28   Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#9c9eae",
    d: "   M 28.48 48.53   L 31.25 48.58   Q 30.03 49.10 28.75 49.13   Q 28.41 49.13 28.48 48.53   Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarvector);
export default __webpack_public_path__ + "static/media/carvector.d7ef19ead15f136ba7f9805a0fcda2ea.svg";
export { ForwardRef as ReactComponent };